import React, { type JSX } from 'react';

import { GroupPath } from 'components';
import { useDefaultConfig } from './hooks';
import { Close, DragHandle } from '@mui/icons-material';
import { IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';

export const DraggableListItem = ({
    item,
    widgetTypeId,
    providedItem,
    isDraggable = true,
}: {
    item: any;
    widgetTypeId: any;
    providedItem?: any;
    isDraggable?: boolean;
}): JSX.Element => {
    const { handleRemoveChannel } = useDefaultConfig(widgetTypeId);
    const getLoadGroupTitle = (el: any): string => {
        if (!el?.name) return '';
        if (typeof el?.totalLoads === 'number' || typeof el?.totalLoads === 'string') {
            return `${el.name} (${el.totalLoads})`;
        }
        return el.name;
    };
    return (
        <ListItem
            {...(providedItem && {
                ref: providedItem.innerRef,
            })}
            className="border-bottom-1 list-item-hover"
            disablePadding
            secondaryAction={
                <IconButton
                    edge="end"
                    aria-label="close"
                    onClick={(): void => {
                        handleRemoveChannel({
                            type: 'selectedNodes',
                            channel: item,
                        });
                    }}
                >
                    <Close />
                </IconButton>
            }
        >
            <ListItemButton
                className="padding-8"
                {...(providedItem && {
                    ...providedItem.draggableProps,
                })}
                role={undefined}
                dense
            >
                {isDraggable && (
                    <ListItemIcon
                        role={undefined}
                        {...(providedItem && {
                            ...providedItem.dragHandleProps,
                        })}
                    >
                        {providedItem && <DragHandle />}
                    </ListItemIcon>
                )}
                <ListItemText
                    primary={
                        <Typography variant="body2" fontWeight={'600'}>
                            {getLoadGroupTitle(item)}
                        </Typography>
                    }
                    secondary={
                        (item['groupPath'] || item['devicePath'] || item?.description) && (
                            <Stack spacing={0.5}>
                                {(item['groupPath'] || item['devicePath']) && (
                                    <GroupPath
                                        pathName={item['groupPath'] ?? item['devicePath']}
                                        deviceName={item['deviceName']}
                                    />
                                )}
                                {Boolean(item?.description) && (
                                    <Typography variant="caption" color="#333D43">
                                        {item.description}
                                    </Typography>
                                )}
                            </Stack>
                        )
                    }
                />
            </ListItemButton>
        </ListItem>
    );
};
